import { useEffect, useState } from 'react'
import { Upload, Tabs, Drawer, Spin, message, Form, Select } from 'antd'
import styles from './index.module.less'
import ImageUpload, { AcceptType } from '@/components/Upload/ImageUpload.tsx'
import {
  startOfflineContract,
  queryLoanOrgList,
  hasLoanOrg,
  saveQuoteDiscountBus,
} from '@/services/goods'
import {
  checkWarningBeforeContract
} from '@/services/order'
import { STriggerModal, SMessage } from 'shj-components'

const SubmitOfflineContract = ({
  state = {},
  setState = () => ({}),
  currentContractList = [],
  quoteId = '',
  title = '',
  orderId = '',
}: any) => {
  const [form] = Form.useForm()
  const [openTieXi, setOpenTieXi] = useState(false)
  const [loanOrgList, setLoanOrgList] = useState([])
  const [saveContractId, setSaveContractId] = useState('')

  useEffect(() => {
    setState({ signDataNew: {} })
  }, [state.signVisible])

  useEffect(() => {
    getLoanOrgList()
  }, [])

  const getLoanOrgList = async () => {
    try {
      const res = await queryLoanOrgList({
        enabled: true,
      })
      if (res?.length) {
        const formatList = res?.map((item: any) => ({
          value: item.institutionNumber,
          label: item.institutionName,
        }))
        setLoanOrgList(formatList)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const onSaveSign = async (id: string) => {
    if (state.submitLoading) {
      return;
    }
    if (!state.signDataNew?.[id] || !state.signDataNew?.[id]?.length) {
      message.info({
        content: '请上传附件图片',
        style: { zIndex: 10000 },
      })
      return false
    }
    const warnRes: any = await checkWarningBeforeContract({
      quoteId,
      quoteContractId: id,
    })
    if (warnRes?.hasWarning) {
      SMessage.confirm({
        title: warnRes?.warningMsg,
        content: <span>抵扣券：{warnRes?.couponName}</span>,
        onOk: async () => {
          setSaveContractId(id)
          setState({ submitLoading: true })
          const hasLoan = await hasLoanOrg({
            quoteId,
            quoteContractId: id,
          })
          if (hasLoan === true) {
            setOpenTieXi(true)
            setState({ submitLoading: false })
            return
          }
          handleSubmit(id)
        },
      })
    } else {
      setSaveContractId(id)
      setState({ submitLoading: true })
      const hasLoan = await hasLoanOrg({
        quoteId,
        quoteContractId: id,
      })
      if (hasLoan === true) {
        setOpenTieXi(true)
        setState({ submitLoading: false })
        return
      }
      await handleSubmit(id)
    }
  }

  const handleSubmit = async (id: string, loanOrgCode?: string) => {
    try {
      setState({ submitLoading: true })
      if (loanOrgCode) {
        const loanOrgName = loanOrgList.find((org: any) => org.value === loanOrgCode)?.label
        const saveRes = await saveQuoteDiscountBus({
          orderId,
          quoteBudgetId: quoteId,
          loanOrgName,
          loanOrgCode,
        })
        if (saveRes?.id) {
          setOpenTieXi(false)
        } else {
          message.info('保存贷款机构报错')
          setState({ submitLoading: false })
          return
        }
      }
      const res = await startOfflineContract({
        quoteId,
        quoteContractId: id,
        attachList: state.signDataNew?.[id],
      })
      message.info(res?.message || '提交成功')
      setState({ submitLoading: false })
    } catch (err) {
      setState({ submitLoading: false })
    }
  }

  const beforeUpload = (file: any) => {
    const type = file.name.split('.').slice(-1).join().toLowerCase()
    const isJpgOrPng = AcceptType.picture.includes(type)
    const isLt20M = file.size / 1024 / 1024 < 20

    if (!isJpgOrPng) {
      message.info(`请上传${AcceptType.picture}格式`)
      return Upload.LIST_IGNORE
    }
    if (!isLt20M) {
      message.info('图片大小不能大于20MB')
      return Upload.LIST_IGNORE
    }
  }

  const onChangeImg = (file: any, id: string) => {
    const newFile = file.map((item: any) => {
      const { originalFilename, filePath } = item.response.data
      return {
        attachType: 'pic',
        busStage: 'draft',
        attachPath: filePath,
        attachName: originalFilename,
      }
    })
    setState({ signDataNew: { ...state.signDataNew, [id]: newFile } })
  }

  /*const onRemoveImg = (file: any) => {
      const id = file.id || file.response.data.id
      const newFiles = state.signDataNew.filter((item: any) => (item.id && item.id !== id) || (item.addKey && item.addKey !== id))
      setState({signDataNew: newFiles});
      if (file.id) request(`/bd-web/elecAttachments/${file.id}`, {method: METHODS.DELETE}).then(res => {
        Toast.show(res.message);
        getSignData()
      })
    }*/
  const closeDialog = () => {
    setOpenTieXi(false)
  }

  const handleOk = async () => {
    form.validateFields().then(async (values: any) => {
      await handleSubmit(saveContractId, values.loanOrgCode)
    })
  }

  const dialogContent = () => (
    <div>
      <Spin spinning={state.submitLoading}>
        <Form
          form={form}
          layout="horizontal"
          style={{
            width: '100%',
          }}
        >
          <Form.Item
            name="loanOrgCode"
            label="贷款机构"
            rules={[{ required: true }]}
            style={{ marginBottom: 0 }}
          >
            <Select style={{ width: '100%' }} options={loanOrgList} />
          </Form.Item>
        </Form>
      </Spin>
    </div>
  )

  return (
    <div>
      <Drawer
        title={title || '发起合同'}
        zIndex={2000}
        width={'62%'}
        open={state.signVisible}
        onClose={() => setState({ signVisible: false })}
        maskClosable={false}
      >
        <div className={styles.modalFull}>
          <Spin spinning={state.submitLoading}>
            <Tabs
              style={{ height: '100%' }}
              tabPosition={'left'}
              items={currentContractList.map((contract: any, index) => {
                const id = String(index + 1)
                return {
                  label: `${contract?.contractTitle}`,
                  key: id,
                  children: (
                    <div className={styles.modalFullWin}>
                      <ImageUpload
                        limit={20}
                        acceptType={AcceptType.picture}
                        readonly={state.signReadOnly}
                        beforeUpload={beforeUpload}
                        onChange={(file: any) => {
                          onChangeImg(file, contract?.contractId)
                        }}
                      />
                      <div className={styles.footer}>
                        <div className={styles.buttonBox}>
                          {!state.signReadOnly && (
                            <div
                              className={styles.addButton}
                              onClick={() => onSaveSign(contract?.contractId)}
                            >
                              <span>保存</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ),
                }
              })}
            />
          </Spin>
        </div>
      </Drawer>
      {openTieXi ? (
        <STriggerModal
          zIndex={2010}
          open={openTieXi}
          onClose={closeDialog}
          title="贷款利息"
          okText="保存"
          cancelText="取消"
          centered={true}
          maskClosable={false}
          destroyOnClose={true}
          onCancel={() => {
            closeDialog()
          }}
          onOk={handleOk}
        >
          {dialogContent()}
        </STriggerModal>
      ) : null}
    </div>
  )
}

export default SubmitOfflineContract
